import React, { useState } from "react";
import PropTypes from "prop-types";
import Copy from "../../assets/copy.png"

export const MessageDropDownOption = ({ innerProps, label, onClick }) => {
    const [showCopiedMessage, setShowCopiedMessage] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(label)
            .then(() => {
                setShowCopiedMessage(true);
                setTimeout(() => {
                    setShowCopiedMessage(false);
                    setTimeout(() => {
                        onClick(label);
                    }, 100);
                }, 500); 
            })
            .catch((err) => {
                console.error('Unable to copy to clipboard', err);
            });
    };

    return (
        <div {...innerProps} className="compose-option-wrapper copy-option cursor-pointer" onClick={handleCopy}>
            <span className="color-black">{label}</span>
            {!showCopiedMessage ? (
                <img src={Copy} alt="copy" />
            ) : (
                <div className="copy-message-popup">Copied!</div>
            )}
        </div>
    );
}

MessageDropDownOption.propTypes = {
    innerProps: PropTypes.object,
    label: PropTypes.string,
    onClick: PropTypes.func,
};